module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABGElEQVR4AezMJUJEURiA0R93iLi7u6xkNkCj4BqnEtnAVJw0kYYmLOHu7v7h8mTsUjkLOOK5f3hRQTUtWMgVHRKw0Ew15XiJMwTRxhY/1qnDW95RwBDPfNminSAxRxoLGI0SgjedPKG3QJoYkc8x5oYZwtwx+aKFN4uoWMRbG1lQZdFGfajq00ZrqFrTRteoutFGe6ja00YTqJrURlZUWbVRFqqyRYseVPSIHknc4qk7EsWIGjzVIeYYwBPTeIs5gpjFXVvEi2PEc4Q7DskQ5yjlFFdOKRHXKOUCZy6cNRpUcYojp5SL+8hkEzObZIpniGIOvTmixHNEMMpvo0SIGgKw88VOgKjDGxsANrzlr+jiZT0MVACjAABmLJNIDoudnwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/adoption.png
// module id = MF9d
// module chunks = 1